
<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form ref="ff" size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.keyWord" clearable placeholder="单号/客户/备注" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="$router.push({ path: 'form' })">新申请</el-button>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" height="100%">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="申请单号" min-width="120">
        <el-link slot-scope="{ row }" type="primary" @click.native="$router.push({ path: row.Id })">{{ row.Code }}</el-link>
      </el-table-column>
      <el-table-column label="客户名称" min-width="200">
        <el-tooltip slot-scope="{ row }" placement="right">
          <div slot="content" class="tppltip_content">
            <p><label>联系方式：</label>{{ row.Linkman }} {{ row.Linktel }}</p>
            <p><label>申请备注：</label>{{ row.Remarks }}</p>
          </div>
          <label>{{ row.Customer }}</label>
        </el-tooltip>
      </el-table-column>
      <el-table-column label="到货时间" min-width="100">
        <template slot-scope="{ row }">{{ $utils.common.parseTime(row.ExpectDate) }}</template>
      </el-table-column>
      <el-table-column prop="Dept.Name" label="部门" min-width="100" />
      <el-table-column prop="Proposer.Name" label="申请人" min-width="100" />
      <el-table-column prop="CreateTime" label="申请时间" min-width="140" />
      <el-table-column label="状态" min-width="60">
        <template slot-scope="{ row }">
          {{ row.State ? '有效' : '无效' }}
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-button type="danger" size="small" icon="el-icon-delete" @click="onDelete">作废/删除</el-button>
      <el-pagination background :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onPager" />
    </div>
  </full-container>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 30,
        ...this.$route.params
      },
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onDrawer () {
      alert(1)
    },
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.product.purchase.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },

    //删除
    onDelete () {
      var ids = this.$refs.tb.selection.map((x) => x.Id)
      if (ids.length == 0) {
        this.$alert("请至少勾选一项要删除的数据", "提示", {
          center: true,
        })
        return
      }
      this.$confirm("作废有效数据/删除无效数据, 是否继续?", "作废/删除", {
        center: true,
      }).then(() => {
        this.$apis.product.purchase.delete(ids).then((res) => {
          this.loadData()
          this.$message({
            message: res || "执行成功！",
            type: "success",
          })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tppltip_content {
  max-width: 400px;
  p {
    white-space: pre-wrap;
    display: flex;
    label {
      width: 60px;
      flex-shrink: 0;
    }
  }
  p + p {
    margin-top: 10px;
  }
}
</style>